// ui/form/elements/Checkbox.tsx
import * as React from "react"
import clx from "classnames"
import styles from "./Checkbox.module.scss"

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  /** Styl kreski zamiast ptaszka, tylko wizualnie */
  indeterminate?: boolean
}

/**
 * Minimal colored checkbox — visual-only `indeterminate`, supports ref, disabled, readOnly.
 */
export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ indeterminate = false, className = "", readOnly, disabled, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="checkbox"
        disabled={disabled}
        readOnly={readOnly}
        className={clx(styles.checkbox, 'et', {
          [styles.indeterminate]: indeterminate,
        }, className)}
        {...props}
      />
    )
  }
)

Checkbox.displayName = "Checkbox"
